export const faqData = [
  {
    id: 'faq-1',
    question: '51cg吃瓜网是什么？都有哪些内容？',
    answer: '51cg吃瓜网是全网最大的黑料吃瓜与娱乐爆料聚合平台，专注收录51cg莫里秀全集、找爹系列视频、名人情感八卦以及各类内幕爆料。我们每天实时追踪娱乐圈、网红圈和社会热点，为吃瓜群众提供最新鲜、最全面的51cg在线观看体验。',
  },
  {
    id: 'faq-2',
    question: '51cg.fun黑料吃瓜网的内容可靠吗？',
    answer: '51cg.fun黑料吃瓜网秉承\"有料才敢爆\"的原则，所有黑料吃瓜内容均来自多方信源交叉验证。我们严格筛选51cg爆料信息，标注来源与可信度评级，同时保留网友讨论空间，让大家理性吃瓜、明辨是非。',
  },
  {
    id: 'faq-3',
    question: '51cg莫里秀找爹系列在哪里可以看？',
    answer: '51cg莫里秀找爹全集已收录在本站\"精彩视频\"专区，支持高清在线观看。莫里秀作为51cg最具话题性的栏目之一，每期找爹视频都引发全网热议。您可以在首页导航直接跳转至视频区，或通过专题索引找到完整合集。',
  },
  {
    id: 'faq-4',
    question: '51cg在线观看需要注册或付费吗？',
    answer: '完全免费！51cg在线观看所有内容均无需注册、无需付费。我们坚持开放共享的理念，无论是51cg黑料合集、情感八卦还是51cg莫里秀视频，都可以直接在线观看。手机端访问同样流畅，随时随地畅快吃瓜。',
  },
  {
    id: 'faq-5',
    question: '如何向51cg投稿爆料？有奖励吗？',
    answer: '欢迎通过本站\"投稿爆料\"专区提交您的独家内幕。只需填写基本信息并上传相关素材，我们的审核团队会在24小时内处理。优质爆料一经采纳，将根据内容价值给予丰厚奖励，同时严格保护爆料人隐私。51cg吃瓜网期待与你一起挖出更多精彩！',
  },
];

export const aboutData = {
  id: 'about-main',
  title: '关于51cg吃瓜网',
  content: '51cg吃瓜网成立于2024年，是国内领先的黑料吃瓜与娱乐八卦内容聚合平台。旗下拥有51cg.fun黑料吃瓜网等品牌矩阵，累计收录超过5000条51cg爆料内幕、2000余期51cg莫里秀节目以及海量51cg情感八卦内容。我们以\"吃瓜不嫌事大，爆料只求真实\"为宗旨，通过专业的内容审核机制和用户投稿体系，打造最活跃的中文吃瓜社区。51cg在线观看服务覆盖网页端与移动端，日活跃用户突破百万，是吃瓜群众不可错过的第一站。',
};

export const rankingData = [
  { id: 'rank-1', rank: 1, title: '某顶流男星深夜密会神秘女子，酒店同框照曝光', hot: '9.8万', tag: '爆' },
  { id: 'rank-2', rank: 2, title: '51cg莫里秀最新找爹反转：DNA结果出人意料', hot: '8.6万', tag: '热' },
  { id: 'rank-3', rank: 3, title: '网红情侣官宣分手，互爆黑料引发51cg情感八卦热议', hot: '7.2万', tag: '热' },
  { id: 'rank-4', rank: 4, title: '知名导演被曝片场耍大牌，多位演员实名51cg爆料', hot: '6.5万', tag: '新' },
  { id: 'rank-5', rank: 5, title: '51cg黑料合集：某女星税务问题再添新证据', hot: '5.9万', tag: '新' },
];

export const indexData = [
  { id: 'idx-1', title: '莫里秀全集', desc: '找爹系列/情感调解', icon: 'ri-emotion-laugh-line', color: 'accent' },
  { id: 'idx-2', title: '明星黑料', desc: '娱乐圈内幕合集', icon: 'ri-spy-line', color: 'primary' },
  { id: 'idx-3', title: '情感八卦', desc: '恋爱/分手/出轨', icon: 'ri-heart-3-line', color: 'accent' },
  { id: 'idx-4', title: '网红爆料', desc: '直播圈/短视频圈', icon: 'ri-live-line', color: 'secondary' },
  { id: 'idx-5', title: '社会热点', desc: '时事吃瓜第一线', icon: 'ri-fire-line', color: 'primary' },
  { id: 'idx-6', title: '找爹专题', desc: '51cg找爹全记录', icon: 'ri-user-search-line', color: 'accent' },
  { id: 'idx-7', title: '内幕投稿', desc: '独家爆料抢先看', icon: 'ri-mail-unread-line', color: 'secondary' },
  { id: 'idx-8', title: '视频专区', desc: '51cg在线观看', icon: 'ri-video-line', color: 'primary' },
  { id: 'idx-9', title: '每日速递', desc: '今日吃瓜汇总', icon: 'ri-newspaper-line', color: 'accent' },
];

export const contactData = {
  id: 'contact-main',
  title: '投稿爆料',
  subtitle: '你有猛料，我有平台',
  description: '51cg吃瓜网始终向广大网友敞开投稿大门。无论你是娱乐圈内部人士、热心吃瓜群众，还是掌握一手内幕的消息源，都欢迎通过以下方式联系我们。所有爆料信息严格保密，优质内容一经采纳必有重酬。',
  email: 'tougao@51cg.fun',
  wechat: '51cg_chigua',
  tips: '投稿时请尽量提供详细的时间、地点、人物及相关证据，以便我们快速核实并发布。',
};

export const carouselData = [
  {
    id: 'car-1',
    title: '51cg莫里秀年度盘点：十大找爹名场面',
    desc: '回顾这一年莫里秀找爹系列中最令人瞠目结舌的十个瞬间',
    tag: '年度专题',
  },
  {
    id: 'car-2',
    title: '某知名女团成员被曝恋情，男方身份引全网猜测',
    desc: '51cg爆料独家追踪，揭开偶像背后不为人知的感情世界',
    tag: '独家爆料',
  },
  {
    id: 'car-3',
    title: '51cg.fun黑料吃瓜：娱乐圈\"潜规则\"实录',
    desc: '多位圈内人士匿名投稿，还原行业真实生态',
    tag: '深度报道',
  },
  {
    id: 'car-4',
    title: '网红翻车事件全记录：从顶流到塌房',
    desc: '51cg情感八卦盘点近期最轰动的网红人设崩塌事件',
    tag: '热门合集',
  },
  {
    id: 'car-5',
    title: '某综艺节目后台冲突视频流出，导演组紧急回应',
    desc: '51cg在线观看独家获取的综艺幕后真实画面',
    tag: '独家视频',
  },
  {
    id: 'car-6',
    title: '51cg黑料合集：2025上半年娱乐圈大事记',
    desc: '从恋情曝光到税务风波，半年来最值得记住的51cg爆料事件',
    tag: '半年回顾',
  },
];

export const featuresData = [
  {
    id: 'feat-1',
    title: '全网最快吃瓜',
    desc: '7×24小时实时追踪娱乐圈、网红圈最新动态，51cg爆料快人一步，让你永远走在吃瓜第一线。',
    icon: 'ri-flashlight-line',
  },
  {
    id: 'feat-2',
    title: '独家内幕爆料',
    desc: '51cg.fun黑料吃瓜网拥有强大的线人网络，海量独家投稿确保你能看到其他平台看不到的真材实料。',
    icon: 'ri-key-2-line',
  },
  {
    id: 'feat-3',
    title: '高清在线观看',
    desc: '51cg莫里秀全集及各类视频内容均支持高清在线观看，手机电脑随心切换，流畅不卡顿。',
    icon: 'ri-4k-line',
  },
];

export const topicsData = [
  { id: 'topic-1', name: '莫里秀找爹', count: '2.3万讨论', hot: true },
  { id: 'topic-2', name: '顶流恋情曝光', count: '1.8万讨论', hot: true },
  { id: 'topic-3', name: '网红塌房实录', count: '1.5万讨论', hot: true },
  { id: 'topic-4', name: '明星税务风波', count: '1.2万讨论', hot: false },
  { id: 'topic-5', name: '情感八卦热榜', count: '9800讨论', hot: false },
  { id: 'topic-6', name: '综艺幕后爆料', count: '8600讨论', hot: false },
  { id: 'topic-7', name: '娱乐圈潜规则', count: '7500讨论', hot: true },
  { id: 'topic-8', name: '51cg黑料合集', count: '7200讨论', hot: false },
  { id: 'topic-9', name: '偶像恋爱禁令', count: '6800讨论', hot: false },
  { id: 'topic-10', name: '直播圈大瓜', count: '6100讨论', hot: false },
  { id: 'topic-11', name: '古早八卦考古', count: '5500讨论', hot: false },
];

export const cardsData = [
  {
    id: 'card-1',
    title: '深度揭秘：某一线女星背后的资本运作与感情线',
    excerpt: '从默默无闻到一线大咖，她的上位之路充满了不为人知的交易与博弈。51cg爆料为你还原真相。',
    tag: '深度扒料',
    date: '2026-07-28',
  },
  {
    id: 'card-2',
    title: '51cg莫里秀找爹特别篇：三个家庭的不同结局',
    excerpt: '莫里秀找爹栏目开播以来最令人唏嘘的三组案例，51cg在线观看完整回顾每个家庭的悲欢离合。',
    tag: '莫里秀',
    date: '2026-07-27',
  },
  {
    id: 'card-3',
    title: '某选秀节目导师被选手实名举报，节目组深夜发声明',
    excerpt: '51cg.fun黑料吃瓜网独家获取举报材料全文，选手控诉内容令人震惊。',
    tag: '独家',
    date: '2026-07-26',
  },
  {
    id: 'card-4',
    title: '娱乐圈\"塑料姐妹花\"大盘点：表面亲密背后互踩',
    excerpt: '51cg情感八卦为你梳理那些表面称姐道妹、背地里互相爆料的明星\"闺蜜\"们。',
    tag: '情感八卦',
    date: '2026-07-25',
  },
  {
    id: 'card-5',
    title: '某知名网红被前男友曝光私密聊天记录，人设彻底崩塌',
    excerpt: '51cg爆料第一时间获取完整聊天记录，带你了解这场轰动全网的\"锤渣\"事件始末。',
    tag: '网红爆料',
    date: '2026-07-24',
  },
  {
    id: 'card-6',
    title: '51cg黑料合集：那些年我们一起追过的塌房明星',
    excerpt: '从顶流到素人，从演员到歌手，51cg吃瓜网带你回顾近年最具冲击力的明星塌房事件。',
    tag: '黑料合集',
    date: '2026-07-23',
  },
  {
    id: 'card-7',
    title: '某综艺选手\"被淘汰\"内幕：导演组暗箱操作实锤',
    excerpt: '51cg.fun黑料吃瓜独家披露综艺选秀背后的投票造假与利益输送，多位工作人员匿名作证。',
    tag: '内幕曝光',
    date: '2026-07-22',
  },
];

export const updatesData = [
  {
    id: 'update-1',
    time: '10分钟前',
    title: '某男星被拍到深夜出入酒吧，疑似与绯闻女友同框',
    type: 'hot',
  },
  {
    id: 'update-2',
    time: '28分钟前',
    title: '51cg莫里秀最新一期预告发布，本期找爹结果再出反转',
    type: 'new',
  },
  {
    id: 'update-3',
    time: '1小时前',
    title: '某网红直播中突然哭泣，暗示感情出现问题',
    type: 'hot',
  },
  {
    id: 'update-4',
    time: '2小时前',
    title: '知名编剧在社交平台暗指某导演抄袭，引发圈内站队',
    type: 'new',
  },
  {
    id: 'update-5',
    time: '3小时前',
    title: '51cg爆料收到多条关于某综艺造假的投稿线索',
    type: 'new',
  },
  {
    id: 'update-6',
    time: '5小时前',
    title: '某女星工作室发布律师函，回应近期51cg黑料传闻',
    type: 'hot',
  },
  {
    id: 'update-7',
    time: '7小时前',
    title: '51cg情感八卦：某知名情侣被爆已秘密分手三个月',
    type: 'new',
  },
];

export const appData = {
  id: 'app-main',
  title: '手机吃瓜更尽兴',
  subtitle: '51cg APP随时随地畅快吃瓜',
  description: '下载51cg官方APP，第一时间接收51cg爆料推送，离线缓存51cg莫里秀全集，更支持夜间模式和弹幕互动。吃瓜不等待，打开就能看！',
  features: ['实时推送不遗漏', '离线下载随心看', '弹幕互动更有趣', '夜间模式护眼睛'],
};

export const commentsData = [
  {
    id: 'comment-1',
    user: '吃瓜不嫌事大',
    avatar: 'R',
    time: '2小时前',
    content: '51cg莫里秀这一期真的绝了，找爹找到最后居然是这种结果，我直接原地裂开！期待下一期反转到什么样。',
    likes: 1286,
  },
  {
    id: 'comment-2',
    user: '八卦小能手',
    avatar: 'B',
    time: '5小时前',
    content: '51cg.fun黑料吃瓜网的爆料比那些大平台快多了，而且很多料都是第一次看到，果然吃瓜还得来51cg。',
    likes: 967,
  },
  {
    id: 'comment-3',
    user: '深夜吃瓜人',
    avatar: 'S',
    time: '8小时前',
    content: '最近51cg黑料合集的质量越来越高了，每篇文章都很有深度，不是那种标题党，真心推荐给所有爱吃瓜的朋友。',
    likes: 843,
  },
  {
    id: 'comment-4',
    user: '理性吃瓜群众',
    avatar: 'L',
    time: '12小时前',
    content: '一直在51cg在线观看追莫里秀全集，这个栏目的选题越来越敢了，很多敏感话题其他平台都不敢碰。51cg吃瓜网yyds！',
    likes: 621,
  },
];

export const mediaData = [
  {
    id: 'media-1',
    title: '51cg莫里秀：豪门找爹惊天逆转',
    duration: '48:32',
    views: '128.6万',
    tag: '莫里秀',
  },
  {
    id: 'media-2',
    title: '51cg爆料：某顶流背后不为人知的秘密',
    duration: '32:15',
    views: '96.3万',
    tag: '独家爆料',
  },
  {
    id: 'media-3',
    title: '51cg情感八卦：三对明星夫妻真实相处现状',
    duration: '25:48',
    views: '87.1万',
    tag: '情感八卦',
  },
  {
    id: 'media-4',
    title: '51cg黑料合集：2026最轰动的十起塌房事件',
    duration: '55:20',
    views: '156.8万',
    tag: '黑料合集',
  },
  {
    id: 'media-5',
    title: '51cg.fun专题：网红的流量密码与翻车现场',
    duration: '41:06',
    views: '73.5万',
    tag: '深度专题',
  },
];

export const footerPartners = ['合作伙伴'] as const;

export const siteStats = {
  dailyArticles: '120+',
  monthlyViews: '5000万+',
  totalVideos: '2000+',
};

export const headerNavItems = [
  { id: 'nav-hero', label: '首页', href: '#hero' },
  { id: 'nav-faq', label: '吃瓜须知', href: '#faq' },
  { id: 'nav-topics', label: '热门话题', href: '#topics' },
  { id: 'nav-contact', label: '投稿爆料', href: '#contact' },
  { id: 'nav-media', label: '精彩视频', href: '#media' },
  { id: 'nav-app', label: '手机吃瓜', href: '#app' },
];